module.exports = __webpack_public_path__ + "img/image_5.1563c55a.png";